var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaperpin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36514 10.1344L11.3049 7.65763C11.5363 7.51103 12.0687 7.3382 12.3465 7.81966C12.4082 7.92768 12.4622 8.23631 12.1845 8.60667L8.36514 12.4028C7.87133 12.7192 6.73094 13.1111 6.11985 12.1482C5.96554 11.8627 5.83745 11.1205 6.55965 10.4353L11.1891 6.19935C11.4437 6.02189 12.1382 5.80121 12.8789 6.33823L14.0594 7.4956C14.2677 7.81966 14.6381 8.02799 13.6196 9.11591L8.96697 14",
    stroke: "#717581",
    strokeWidth: 0.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperpin);
export default __webpack_public_path__ + "static/media/paperpin.098e3c56b1def2f5bca6d3ab1450a1af.svg";
export { ForwardRef as ReactComponent };